
import CloudChange from "../../../assets/outline/CloudChange.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudChangeIcon({ className, dataTestid = "CloudChangeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudChange data-testid={dataTestid} className={classes} {...rest} />
  );
}
